// Pure lesson-URL parser shared by the Hub's Messages page and the partner embed.
// Returns the lesson slug for a public lesson or Hub lesson URL on one of `hosts`,
// or null. It does not check the catalog — callers decide whether the slug exists.

// /lesson/:category/:slug, /guide/:category/:slug, /guide/:slug — the slug is
// always the last segment (the :category exists only so sheet URLs resolve).
const PUBLIC_LESSON_RE = /^\/(?:lesson|guide)(?:\/[^/]+)?\/([^/]+?)\/?$/;
const HUB_LESSON_RE = /^\/hub\/lessons-and-guides\/([^/]+?)\/?$/;

export default function lessonSlugFromUrl(href: string, hosts: string[]): string | null {
  let url: URL;
  try {
    url = new URL(href);
  } catch {
    return null;
  }
  if (url.protocol !== 'https:' && url.protocol !== 'http:') return null;
  if (hosts.indexOf(url.host) === -1) return null;
  const match = url.pathname.match(PUBLIC_LESSON_RE) || url.pathname.match(HUB_LESSON_RE);
  if (!match) return null;
  try {
    return decodeURIComponent(match[1]);
  } catch {
    return null;
  }
}
